import './vendor';
import './helpers';
import Swiper, { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
import select2 from 'select2';
import { fancybox } from '@fancyapps/fancybox';
import inputmask from 'inputmask/dist/jquery.inputmask';
import datetimepicker from 'jquery-datetimepicker';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/localization/messages_ru.js';

$.datetimepicker.setLocale('ru');

Swiper.use([Navigation, Pagination, Thumbs, Autoplay]);

const $document = $(document);

const $window = $(window);

const $html = $('html');

const $body = $('body');

window.windowTitle = '';

const app = {
	isMobile: () => $window.outerWidth() < 1025,
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					window.scrollTo(0, $target.offset().top - $('.header').outerHeight());
				}
			});

			$('[data-fancybox]').fancybox({
				touch: false,
				autoFocus: false,
				backFocus: false,
				afterLoad() {
					initApps();
				},
				afterClose: function afterClose() {
					if(windowTitle != '') document.title = windowTitle;

					window.windowTitle = '';
				},
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			$('.js-show-hide').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.data('target'));

				e.preventDefault();
				if ($target.length) {
					$this.toggleClass('is-active');
					if ($this.hasClass('is-active')) {
						$target.stop().slideDown(500);
						$this.find('span').text($this.data('on'));
					} else {
						$target.stop().slideUp(500);
						$this.find('span').text($this.data('off'));
					}
				}
			});

			$('.js-print').on('click', (e) => {
				e.preventDefault();
				window.print();
			});
		},
	},
	header: {
		init($header) {
			let fixed = false;

			$window.on('scroll', () => {
				if ($window.scrollTop() > $header.outerHeight()) {
					if (!fixed) {
						$header.css({
							height: $header.outerHeight(),
						});
						$header.addClass('is-fixed');
						fixed = true;
					}
				} else if (fixed) {
					$header.removeClass('is-fixed');
					$header.css({
						height: '',
					});
					fixed = false;
				}
			});

			$header.find('.header__menu__item__arrow').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $list = $this.closest('.header__menu__item').find('.header__menu__item__list');

				e.preventDefault();
				$this.toggleClass('is-active');
				if ($this.hasClass('is-active')) {
					$list.stop().slideDown(250);
				} else {
					$list.stop().slideUp(250);
				}
			});
		},
	},
	indexHero: {
		init($hero) {
			$hero.find('.index-hero__mute').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$this.toggleClass('is-active');
				$hero.find('.index-hero__video video')[0].muted = $this.hasClass('is-active');
			});
		},
	},
	lifestyle: {
		init($lifestyle) {
			if (app.isMobile()) {
				new Swiper($lifestyle.find('.swiper-container')[0], {
					slidesPerView: 1,
					spaceBetween: 22,
					pagination: {
						el: $lifestyle.find('.lifestyle__pager')[0],
						clickable: true,
					},
				});
			}
		},
	},
	lifestyleItem: {
		init($item) {
			if ($item.find('.swiper-container').length) {
				new Swiper($item.find('.swiper-container')[0], {
					allowTouchMove: false,
					pagination: {
						el: $item.find('.lifestyle__item__image__pager')[0],
						clickable: true,
					},
				});
			}
		},
	},
	lifestyleCarousel: {
		init($carousel) {
			new Swiper($carousel.find('.lifestyle-carousel__slider > .swiper-container')[0], {
				loop: true,
				loopAdditionalSlides: 3,
				autoplay: {
					delay: 2500,
				},
				slidesPerView: 1,
				spaceBetween: 22,
				roundLengths: true,
				navigation: {
					prevEl: $carousel.find('.lifestyle-carousel__slider__prev')[0],
					nextEl: $carousel.find('.lifestyle-carousel__slider__next')[0],
				},
				breakpoints: {
					1025: {
						slidesPerView: 3,
						spaceBetween: 38,
					}
				}
			});
		},
	},
	select: {
		init($select) {
			$select.find('select').select2({
				minimumResultsForSearch: $select.data('search') ? 5 : Infinity,
				dropdownParent: $select,
			});
		},
	},
	mask: {
		init($mask) {
			$mask.inputmask($mask.data('mask').toString(), {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
		},
	},
	// form: {
	// 	init($form) {
	// 		let validator = $form.validate({
	// 			lang: 'ru',
	// 			submitHandler(form) {
	// 				if ($form.data('type') === 'submit') {
	// 					form.submit();
	// 				} else {
	// 					$.ajax({
	// 						type: $form.attr('method'),
	// 						url: $form.attr('action'),
	// 						data: $form.serialize(),
	// 						dataType: 'json',
	// 						success(result) {
	// 							if (result.result === true) {
	// 								$form[0].reset();
	// 								$.fancybox.close();
	// 							}
	// 							$.fancybox.open(`<div class="modal modal--success">
	// 								<div class="modal__success">
	// 									<div class="modal__success__icon">
	// 										<img src="${result.icon}" alt="${result.title}">
	// 									</div>
	// 									<div class="modal__success__title">${result.title}</div>
	// 									<div class="modal__success__text">${result.message}</div>
	// 								</div>
	// 								<button class="modal__close" type="button" data-fancybox-close><span></span></button>
	// 							</div>`, {
	// 								touch: false,
	// 								autoFocus: false,
	// 								backFocus: false,
	// 							});
	// 						},
	// 					});
	// 				}
	// 			},
	// 		});
	// 	},
	// },
	indexAbout: {
		init($about) {
			let $backs = $about.find('.index-about__back__item');

			let slider = new Swiper($about.find('.swiper-container')[0], {
				loop: true,
				loopAdditionalSlides: 2,
				autoplay: {
					delay: 2500,
				},
				direction: 'horizontal',
				navigation: {
					prevEl: $about.find('.index-about__slider__arrows__prev')[0],
					nextEl: $about.find('.index-about__slider__arrows__next')[0],
				},
				pagination: {
					el: $about.find('.index-about__slider__pager')[0],
					clickable: true,
				},
				breakpoints: {
					1025: {
						direction: 'vertical',
					},
				},
			});

			slider.on('slideChange', () => {
				$backs.removeClass('is-active');
				$backs.eq(slider.realIndex).addClass('is-active');
			});
		},
	},
	history: {
		init($history) {
			let slider = new Swiper($history.find('.swiper-container')[0], {
				loop: true,
				loopAdditionalSlides: 2,
				autoplay: {
					delay: 2500,
				},
				spaceBetween: 8,
				navigation: {
					prevEl: $history.find('.history__gallery__prev')[0],
					nextEl: $history.find('.history__gallery__next')[0],
				},
				breakpoints: {
					1025: {
						spaceBetween: 34,
					},
				},
			});
		},
	},
	carousel: {
		init($carousel) {
			let slider = new Swiper($carousel.find('.swiper-container')[0], {
				loop: true,
				loopAdditionalSlides: 2,
				autoplay: {
					delay: 2500,
				},
				slidesPerView: 1.1,
				spaceBetween: 13,
				navigation: {
					prevEl: $carousel.find('.carousel__prev')[0],
					nextEl: $carousel.find('.carousel__next')[0],
				},
				breakpoints: {
					1025: {
						slidesPerView: 3,
						spaceBetween: 25,
					},
				},
			});
		},
	},
	banner: {
		init($banner) {
			let slider = new Swiper($banner.find('.swiper-container')[0], {
				loop: true,
				slidesPerView: 1,
				autoplay: {
					delay: 2500,
				},
				navigation: {
					prevEl: $banner.find('.banner__prev')[0],
					nextEl: $banner.find('.banner__next')[0],
				},
				pagination: {
					el: $banner.find('.banner__pager')[0],
					clickable: true,
				},
			});
		},
	},
	benefits: {
		init($benefits) {
			if (app.isMobile()) {
				new Swiper($benefits.find('.swiper-container')[0], {
					slidesPerView: 1,
					autoHeight: true,
					pagination: {
						el: $benefits.find('.benefits__pager')[0],
						clickable: true,
					},
				});
			}
		},
	},
	rent: {
		init($rent) {
			if (app.isMobile()) {
				new Swiper($rent.find('.swiper-container')[0], {
					slidesPerView: 1,
					spaceBetween: 17,
				});
			}
		},
	},
	gallery: {
		init($gallery) {
			if (app.isMobile()) {
				let slider = new Swiper($gallery.find('.swiper-container')[0], {
					slidesPerView: 'auto',
					spaceBetween: 14,
				});
			}
		},
	},
	contacts: {
		init($contacts) {
			let $map = $contacts.find('.contacts__map');

			let options = $map.data();

			app.scriptLoading('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
				ymaps.ready(() => {
					let map = new ymaps.Map($map[0], {
						center: [options.lat, options.lng],
						zoom: options.zoom,
						controls: [],
					}, {});

					map.behaviors.disable('scrollZoom');
					map.behaviors.disable('drag');

					map.geoObjects.add(new ymaps.Placemark([options.lat, options.lng], {}, {
						iconLayout: 'default#image',
						iconImageHref: options.icon,
						iconImageSize: [52, 73],
						iconImageOffset: [-26, -36],
					}));

					if (app.isMobile()) {
						map.setCenter([options.lat - (0.0012 / (320 / $window.outerWidth())), options.lng]);
					}
				});
			});
		},
	},
	accordion: {
		init($accordion) {
			let $items = $accordion.find('.accordion__item');

			let $contents = $accordion.find('.accordion__item__content');

			$items.find('.accordion__item__head').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $thisItem = $this.closest('.accordion__item');

				e.preventDefault();
				if ($thisItem.hasClass('is-active')) {
					$thisItem.removeClass('is-active');
					$thisItem.find('.accordion__item__content').stop().slideUp(400);
				} else {
					$items.removeClass('is-active');
					$contents.stop().slideUp(400);
					$thisItem.addClass('is-active');
					$thisItem.find('.accordion__item__content').stop().slideDown(400);
				}
			});
		},
	},
	cooking: {
		init($cooking) {
			let $tabsLink = $cooking.find('.cooking__tabs__list a');

			let $tabsItem = $cooking.find('.cooking__tabs__item');

			$tabsLink.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$tabsLink.removeClass('is-active');
				$tabsItem.removeClass('is-active');
				$this.addClass('is-active');
				$tabsItem.eq($this.closest('li').index()).addClass('is-active');
			});
		},
	},
	inputFile: {
		init($file) {
			let $label = $file.find('.input__file__label');

			$file.on('change', 'input[type="file"]', (e) => {
				if (e.target.files.length === 0) {
					$label.text($label.data('label'));
					$file.removeClass('is-file-selected');
				} else if (e.target.files.length === 1) {
					$label.text(e.target.files[0].name);
					$file.addClass('is-file-selected');
				} else {
					$label.text(`Выбрано файлов: ${e.target.files.length}`);
					$file.addClass('is-file-selected');
				}
				$(e.currentTarget).valid();
			});

			$file.find('.input__file__remove').on('click', (e) => {
				e.preventDefault();
				$file.find('input[type="file"]').val('').trigger('change');
			});
		},
	},
	basket: {
		init($basket) {
			$basket.find('.basket__area__show-map button').on('click', (e) => {
				e.preventDefault();

				let $this = $(e.currentTarget);

				$this.toggleClass('is-active');

				if ($this.hasClass('is-active')) {
					$this.find('span').text($this.data('on'));
					$basket.find('.basket__area__map').stop().slideDown(400);
				} else {
					$this.find('span').text($this.data('off'));
					$basket.find('.basket__area__map').stop().slideUp(400);
				}
			});

			$basket.find('.basket__area__select__item').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $select = $this.closest('.basket__area__select');

				let $label = $select.find('.basket__area__select__label');

				let $labelItems = $label.find('.basket__area__select__label__item');

				let $input = $select.find('.basket__area__select__input');

				e.preventDefault();
				$select.addClass('is-filled');
				$labelItems.removeClass('is-active');
				$labelItems.filter(`[data-value="${$this.data('value')}"]`).addClass('is-active');
				$input.val($this.data('value'));
				$select.removeClass('is-show');
			});

			$basket.find('.basket__area__select__label').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $select = $this.closest('.basket__area__select');

				e.preventDefault();
				$select.toggleClass('is-show');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.basket__area__select').length) {
					$basket.find('.basket__area__select').removeClass('is-show');
				}
			});

			$basket.find('.basket__pickup input').on('change', (e) => {
				if ($(e.currentTarget).is(':checked')) {
					$basket.find('.basket__area__address').addClass('is-disabled');
					$basket.find('.basket__area__map').addClass('is-disabled');
					$basket.find('.basket__area__show-map button span').text($basket.find('.basket__area__show-map button').data('off'));
					$basket.find('.basket__area__show-map button').removeClass('is-active');
				} else {
					$basket.find('.basket__area__address').removeClass('is-disabled');
					$basket.find('.basket__area__map').removeClass('is-disabled');
				}
			});
		},
	},
	counter: {
		init($counter) {
			$counter.find('.counter__plus').on('click', (e) => {
				let $item = $(e.currentTarget).closest('.js-counter-item');

				let $input = $item.find('.counter__input');

				let $count = $item.find('.counter__count');

				let $total = $item.find('.js-counter-total');

				e.preventDefault();
				$item.data('count', parseFloat($item.data('count')) + parseFloat($item.data('step')));
				if (parseFloat($item.data('count')) > parseFloat($item.data('max'))) {
					$item.data('count', $item.data('max')).attr('data-count', $item.data('max'));
				}
				$item.attr('data-count', $item.data('count'));
				$count.text($item.data('count'));
				$input.val($item.data('count'));
				$total.text(parseFloat($item.data('count')) * parseFloat($item.data('price')));
			});

			$counter.find('.counter__minus').on('click', (e) => {
				let $item = $(e.currentTarget).closest('.js-counter-item');

				let $input = $item.find('.counter__input');

				let $count = $item.find('.counter__count');

				let $total = $item.find('.js-counter-total');

				e.preventDefault();
				$item.data('count', parseFloat($item.data('count')) - parseFloat($item.data('step')));
				if (parseFloat($item.data('count')) < parseFloat($item.data('min'))) {
					$item.data('count', $item.data('min'))
				}
				$item.attr('data-count', $item.data('count'));
				$count.text($item.data('count'));
				$input.val($item.data('count'));
				$total.text(parseFloat($item.data('count')) * parseFloat($item.data('price')));
			});
		},
	},
	deliveryFilter: {
		init($filter) {
			// const calcCount = () => {
			// 	const count = $filter.find('.delivery__catalog__list input[type="checkbox"]:checked').length;

			// 	$filter.find('.delivery__catalog__label__count').text(count > 0 ? `(${count})` : '');
			// };

			$filter.find('.delivery__catalog__label').on('click', (e) => {
				e.preventDefault();
				$filter.find('.delivery__catalog').toggleClass('is-show');
			});

			$filter.find('.delivery__sort__select__label').on('click', (e) => {
				e.preventDefault();
				$filter.find('.delivery__sort__select').toggleClass('is-show');
			});

			$filter.find('.delivery__sort__select input').on('change', (e) => {
				e.preventDefault();
				$filter.find('.delivery__sort__select__label').text($(e.currentTarget).closest('label').text().trim());
			});

			$filter.find('.delivery__catalog__apply a, .delivery__catalog__apply button').on('click', (e) => {
				e.preventDefault();
				$filter.find('.delivery__catalog').removeClass('is-show');
				// calcCount();
			});

			$filter.find('.delivery__catalog__type input').on('change', (e) => {
				$filter.find('.delivery__catalog__list').removeClass('is-active');
				$filter.find(`.delivery__catalog__list[data-list="${$(e.currentTarget).data('target')}"]`).addClass('is-active');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.delivery__catalog').length) {
					$('.delivery__catalog').removeClass('is-show');
				}

				if (!$target.closest('.delivery__sort__select').length) {
					$('.delivery__sort__select').removeClass('is-show');
				}
			});
		},
	},
	deliveryItem: {
		init($item) {
			$item.find('.js-delivery-item-add').on('click', (e) => {
				e.preventDefault();

				$item.addClass('is-added');
			});
		},
	},
	corners: {
		init($corners) {
			if (app.isMobile()) {
				new Swiper($corners.find('.swiper-container')[0], {
					slidesPerView: 1,
					spaceBetween: 22,
					pagination: {
						el: $corners.find('.corners__pager')[0],
						clickable: true,
					},
				});
			}
		},
	},
	popular: {
		init($popular) {
			let slider = new Swiper($popular.find('.swiper-container')[0], {
				slidesPerView: 'auto',
				spaceBetween: 13,
				navigation: {
					prevEl: $popular.find('.corners-inner__popular__prev')[0],
					nextEl: $popular.find('.corners-inner__popular__next')[0],
				},
				breakpoints: {
					1025: {
						spaceBetween: 34,
					},
				},
			});
		},
	},
	calendar: {
		init($input) {
			$input.attr('type', 'text');
			$input.inputmask('99.99.9999', {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
			$input.datetimepicker({
				timepicker:false,
				format:'d.m.Y'
			});
		},
	},
	galleryModal: {
		init($gallery) {
			setTimeout(() => {
				let slider = new Swiper($gallery.find('.gallery-modal__big .swiper-container')[0], {
					slidesPerView: 'auto',
					spaceBetween: 13,
					navigation: {
						prevEl: $gallery.find('.gallery-modal__big__prev')[0],
						nextEl: $gallery.find('.gallery-modal__big__next')[0],
					},
					thumbs: {
						swiper: $gallery.find('.carousel .swiper-container')[0].swiper,
					},
					breakpoints: {
						1025: {
							slidesPerView: 1,
							spaceBetween: 34,
						},
					},
				});
			}, 0);
		},
	},
	deliveryCart: {
		init($cart) {
			let $tabsLink = $cart.find('.delivery-cart__tabs__list a');

			let $tabsItem = $cart.find('.delivery-cart__tabs__item');

			$tabsLink.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$tabsLink.removeClass('is-active');
				$tabsItem.removeClass('is-active');
				$this.addClass('is-active');
				$tabsItem.eq($this.closest('li').index()).addClass('is-active');
			});
		},
	},
	scriptLoading(src, callback) {
		let script = document.createElement('script');

		let loaded;

		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	},
};

app.global.init();

window.initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);

		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {
				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};


initApps();
